import { Heart } from './Heart';
import { GlobalContext } from '../context/GlobalState';
import { useContext } from 'react';
import { ApplyButton } from './ApplyButton';
import { getLocalAvatar, resolveAvatarUrl } from '../utils/avatarUtils';

export const BandCard = ({ band }) => {
  const { isLoggedIn } = useContext(GlobalContext);
  const {
    _id,
    name,
    genre,
    description,
    looking_for,
    image_url,
    uploadedImageId,
  } = band;

  return (
    <li className='card'>
      {isLoggedIn && (
        <div className='card-favorite'>
          <Heart cardId={_id} />
        </div>
      )}
      <img
        src={resolveAvatarUrl(image_url, name, uploadedImageId)}
        alt='musician'
        loading='lazy'
        decoding='async'
        onError={e => {
          e.currentTarget.onerror = null;
          e.currentTarget.src = getLocalAvatar(name);
        }}
      />
      <div className='card-title'>{name}</div>
      <div className='card-divider' />
      <div className='card-meta'>Genre: {genre}</div>
      <div className='card-description'>{description}</div>
      <div className='card-section'>
        <span className='card-section-label'>Looking For</span>
        {looking_for.map(element => (
          <span className='chip searching-for' key={element}>
            {element}
          </span>
        ))}
      </div>
      {isLoggedIn && (
        <div className='container-card-bottom'>
          <ApplyButton card={band} />
        </div>
      )}
    </li>
  );
};
